import React from 'react';
// import LazyLoad from 'react-lazy-load';

import classes from './ProfilePic.module.css';

import defaultAvatar from '../../assets/default-avatar.png';
import editIconBlue from '../../assets/icons/icon-edit-blue.png';

const profilePic = (props) => {
    // Log(props.userProfilePic);
    let styleClasses = [classes.ProfilePicSection];

    if (props.styleclass !== undefined) {
        const styles = props.styleclass.split(' ');
        for (let style in styles) {
            styleClasses.push(classes[styles[style].trim()]);
        }
    }

    return (
        <div className={styleClasses.join(' ')}>
            <div className={classes.ProfilePicContainer}>
                {props.editable ?
                    <label className={classes.UploadThumbnailFalseButton}>
                        <input
                            type="file"
                            onChange={props.onImageFileSelected}
                            onClick={(event) => { event.target.value = null }}
                            accept='.jpeg , .png , image/jpeg , image/png'
                        />
                        <div className={classes.ChangePicContainer}>
                            <img
                                className={classes.ProfilePic}
                                src={
                                    props.userProfilePic !== '' && props.userProfilePic !== null && props.userProfilePic !== undefined
                                        ? props.userProfilePic
                                        : defaultAvatar}
                                alt="Profile Pic"
                            />
                            <div className={classes.ChangePicButton}>UPDATE</div>
                            <div className={classes.EditButton}>
                                <img
                                    className={classes.EditIcon}
                                    alt="Edit Icon"
                                    src={editIconBlue}
                                />
                            </div>
                        </div>

                    </label>
                    // : props.lazyLoad
                    //     ? <LazyLoad offsetVertical={500} offsetHorizontal={500}>
                    //         <img
                    //             className={classes.ProfilePic}
                    //             src={
                    //                 props.userProfilePic !== '' && props.userProfilePic !== null && props.userProfilePic !== undefined
                    //                     ? props.userProfilePic
                    //                     : defaultAvatar}
                    //             alt="Profile Pic"
                    //         />
                    //     </LazyLoad>
                    //     : 
                    : <img
                        className={classes.ProfilePic}
                        src={
                            props.userProfilePic !== '' && props.userProfilePic !== null && props.userProfilePic !== undefined
                                ? props.userProfilePic
                                : defaultAvatar}
                        alt="Profile Pic"
                    />
                }
                <img
                    className={classes.Badge}
                    // src={icons.owlBlueIcon}
                    alt="Profile Pic"
                />
            </div>
        </div>
    )
}

export default profilePic;